import mirror from 'mirror-to-object-pairs';

export const modals = mirror([
  // Modals
  'ImagePickerModal',
  'ConfirmationModal',
  'AlertModal',
  'InviteSuggestionModal',
  'TimestampsModal',
  'AllowNotificationsModal',
  'ChangeSubscriptionPlanModal',
  'AddCreditCardModal',
  'SubscribeSuggestionModal',
  'MobileAppSuggestionModal',
  'PostEditorModal',
  'PostViewModal',
  'ReportModal',
  'OptionsMenuModal',
  'PickerModal',
  'LikesModal',
  'TrackFeedbackFormModal',
  'PurchaseCreditsModal',
  'ChooseTrackFeedbackOptionModal',
  'LoaderModal',
]);
